import { render } from "./MessagesViewModal.vue?vue&type=template&id=b1a13218&ts=true"
import script from "./MessagesViewModal.vue?vue&type=script&lang=ts"
export * from "./MessagesViewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__